/* istanbul ignore file */
import { generateStore, withStateHydration } from '@noths/polaris-client-next-redux';
import type { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from './combinedReducer';
import { combinedReducer } from './combinedReducer';
import { GAMiddleware } from './GAMiddleware';
import { productsQueryURLSyncMiddleware } from './productsQuery/middleware/productsQueryURLSync';

export const { getStore, useStore } = generateStore<ReduxApplicationState>({
  reducer: withStateHydration<ReduxApplicationState>(combinedReducer),
  middleware: [GAMiddleware, productsQueryURLSyncMiddleware],
});

export type AppThunkDispatch = ThunkDispatch<ReduxApplicationState, undefined, AnyAction>;
